import { localStorageKeys } from '../constants/localStorage';

const loginIdsStorage = {
  /**
   * Adiciona um ID à lista de IDs salvos
   */
  addId: (id: string): void => {
    if (!id || id.trim() === '') return;
    
    const ids = loginIdsStorage.getIds();
    if (!ids.includes(id)) {
      ids.push(id);
      // Manter apenas os últimos 10 IDs
      const limitedIds = ids.slice(-10);
      localStorage.setItem(localStorageKeys.loginIds, JSON.stringify(limitedIds));
    }
  },

  /**
   * Obtém a lista de IDs salvos
   */
  getIds: (): string[] => {
    try {
      const item = localStorage.getItem(localStorageKeys.loginIds);
      if (!item) return [];
      return JSON.parse(item) as string[];
    } catch {
      return [];
    }
  },

  /**
   * Remove um ID da lista
   */
  removeId: (id: string): void => {
    const ids = loginIdsStorage.getIds();
    const filteredIds = ids.filter((savedId) => savedId !== id);
    localStorage.setItem(localStorageKeys.loginIds, JSON.stringify(filteredIds));
  },

  /**
   * Limpa todos os IDs salvos
   */
  clear: (): void => {
    localStorage.removeItem(localStorageKeys.loginIds);
  },
};

export default loginIdsStorage;

